import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
import emailAnimation from "../../../../../../../assets/email-animation.json";
import { ReactComponent as CloseIcon } from "../../../../../../../assets/close.svg";

interface SuccessModalProps {
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ onClose }) => {
  const { t } = useTranslation("myArea");
  const [loopCount, setLoopCount] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const handleLoopComplete = () => {
    setLoopCount((prev) => {
      if (prev + 1 >= 3) {
        setIsPlaying(false);
      }
      return prev + 1;
    });
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg lg:w-1/3 w-4/5">
        <div className="flex justify-between items-center mb-3">
          <span className="text-lg font-bold">
            {t("assessments.feedback360.success-title")}
          </span>
          <CloseIcon onClick={onClose} className="cursor-pointer" />
        </div>
        <p className="mt-4">{t("assessments.feedback360.success-message")}</p>
        <div className="flex flex-col items-center justify-center my-4">
          <div className="w-40 h-40">
            <Lottie
              animationData={emailAnimation}
              loop={isPlaying}
              onLoopComplete={handleLoopComplete}
              style={{ width: "146px", height: "146px" }}
            />
          </div>

          <p className="mt-4 text-sm text-gray-600">
            {t("assessments.feedback360.processing-time")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
